// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // Power Automate flow that appends awareness-posters leads to the Excel sheet
  leadsFlowUrl: 'https://default5a6c6ff13f05416c861fbcd1fe707f.0e.environment.api.powerplatform.com:443/powerautomate/automations/direct/cu/12/workflows/eeed51fe877a4a81a1c004853433e5bf/triggers/manual/paths/invoke?api-version=1&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=8BOwmiACViyGJ6R6WJRKFbDbGKfKLSW7PAGsUga9RUI'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
